import React, { useContext } from 'react';
import { StateContext } from "../../state/index";
import LoadingPage from "../library/LoadingPage";

export const PollingForComplete = () => {
  const [{configuration}] = useContext(StateContext);

  return (
    <LoadingPage title={configuration.pollingForComplete.title} description={configuration.pollingForComplete.description}/>
  );
};

export default PollingForComplete;
